var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoResult = function SvgNoResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "no_liquidity")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4EAE\\u8272\\u6A21\\u5F0F-\\u56FE\\u6807",
    transform: "translate(-961.000000, -474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no_liquidity",
    transform: "translate(961.000000, 474.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-2)",
    fillOpacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#727272",
    points: "0 30.1053723 60 30.1053723 60 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#ABABAB",
    points: "0.00577273198 59.8096615 59.9944493 59.8096615 59.9944493 30.0566589 0.00577273198 30.0566589"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.311705,29.7519946 L30.311705,29.7519946 C30.067696,29.7519946 29.8252413,29.7459998 29.5843407,29.7342323 C19.0371153,29.2197931 14.137176,16.2924259 21.5689024,8.7421365 L30.1738255,0 L38.860899,8.66265042 C46.4940049,16.2739975 41.3929081,29.5046552 30.650964,29.7482201 C30.5381737,29.7506624 30.4251613,29.7519946 30.311705,29.7519946",
    id: "Fill-3",
    fillOpacity: 0.4,
    fill: "#727272",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.311705,59.7519946 L30.311705,59.7519946 C30.067696,59.7519946 29.8252413,59.7459998 29.5843407,59.7342323 C19.0371153,59.2197931 14.137176,46.2924259 21.5689024,38.7421365 L30.1738255,30 L38.860899,38.6626504 C46.4940049,46.2739975 41.3929081,59.5046552 30.650964,59.7482201 C30.5381737,59.7506624 30.4251613,59.7519946 30.311705,59.7519946",
    id: "Fill-5",
    fillOpacity: 0.4,
    fill: "#727272",
    mask: "url(#mask-2)"
  }))))));
};

export { SvgNoResult as ReactComponent };
export default __webpack_public_path__ + "4855f07d0d7343e737028b07bd9be5fa.svg";